/**
 * The MintUpcoming container
 */
import { ScrollToTop as useScrollToTop } from "@bkry/bowline-components/Utils";
import { listTiersForProject } from "@bkry/bowline-redux/mintTiers";
import { env } from "@bkry/bowline-utils";
import { useWeb3React } from "@web3-react/core";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import ReactPlayer from "react-player";
import { useDispatch } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import ArtistModal from "../components/ArtistModal";
import Faq from "../components/Faq";
import MintAnnouncement from "../components/MintAnnouncement";
import MintPassCard from "../components/Minting/MintPassCard";
import MintingWrapper from "../components/Minting/MintingWrapper";
import Page from "../components/Page/Page-component";
import TvBundleSection from "../components/PreorderBundleSection/TvBundleSection";
import ImageContentSplit from "../components/ImageContentSplit";

// import RaffleWinnerAnnouncement from "../components/RaffleWinnerAnnouncement";

const { REACT_APP_PROJECT_ID, REACT_APP_CDN_PATH } = env;
/**
 * TX1GenesisMint container, the landing page for logged in users
 */
const TX1GenesisMint = ({ mintTierId }, context) => {
  useScrollToTop();
  const dispatch = useDispatch();
  const { account } = useWeb3React();

  useEffect(() => {
    dispatch(
      listTiersForProject({
        projectId: REACT_APP_PROJECT_ID,
        address: account,
      })
    );
    window.scrollTo(0, 0);
  }, [dispatch, REACT_APP_PROJECT_ID, account]);

  return (
    <Page id="home" title="Samsung TX1 Genesis Edition" className="mb-3">
      <MintingWrapper
        mintTierId={mintTierId}
        tokenTitle={"TX1 Genesis Edition"}
        successImageUrl={
          (REACT_APP_CDN_PATH || "") + "/images/tx1/TX1_placeholder.png"
        }
      >
        <Row className="gy-5 bigger-margin-bottom">
          <Col
            xs={12}
            lg={{ size: 4, offset: 2 }}
            className="justify-content-center pe-lg-5"
          >
            <div>
              <ReactPlayer
                url={
                  (REACT_APP_CDN_PATH || "") +
                  "/videos/tx1/tx1_paul_milinski.mp4"
                }
                controls={true}
                playing={true}
                playsinline
                muted={true}
                loop={true}
                width="100%"
                height="auto"
              />
            </div>
          </Col>
          <Col
            className="d-flex flex-column minting-wrapper ps-lg-5"
            xs={12}
            lg={6}
          >
            {mintTierId && <MintPassCard mintTierId={mintTierId} />}
            {!mintTierId && <span>Mint Info Missing</span>}
          </Col>
        </Row>
        <MintAnnouncement roadmapSlug="mint-announcement-tx1-genesis" />
        <ImageContentSplit
          title={context.t("tx1.raffle.teaser.title")}
          content={context.t("tx1.raffle.teaser.content")}
          imageUrl={
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/gen3rator-with-chip.png"
          }
          ctaLink={"/community/benefits/"}
          ctaText={context.t("tx1.raffle.teaser.cta")}
          leftAligned
        />
        <TvBundleSection />
        {/* ArtistTabsGenesis */}
        <Row className="d-flex justify-content-between bigger-margin-top">
          <Row className="bigger-margin-top d-flex flex-column justify-content-center align-items-center">
            <Col xs={12}>
              <h2 className="text-center pb-5">
                {context.t("artist.tx1ge.title")}
              </h2>
              <ReactPlayer
                url={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/PaulMilinski/1300x433_Artist.mp4"
                }
                controls={false}
                playing={true}
                playsinline
                muted={true}
                loop={true}
                width="100%"
                height="auto"
              />
            </Col>
            <Col xs={12} lg={8} className="mt-5">
              <h3 className="text-center pb-4">
                {context.t("artist.paulmilinski.name")}
              </h3>
              <p className="text-center">
                {context.t("artist.paulmilinski.text")}
              </p>
              <div className="d-flex justify-content-center">
                <ArtistModal
                  subHeader={context.t("artist.modal.paulmilinski.subHeader")}
                  headline={context.t("artist.modal.paulmilinski.headline")}
                  text={context.t("artist.modal.paulmilinski.text")}
                  items={[
                    {
                      src:
                        (REACT_APP_CDN_PATH || "") +
                        "/images/PaulMilinski/800x800_Artist.png",
                      altText: "Paul Milinski",
                      type: "img",
                      key: 0,
                    },
                    {
                      src:
                        (REACT_APP_CDN_PATH || "") +
                        "/images/PaulMilinski/A Gathering Of Shade_small.mp4",
                      altText: "A Gathering Of Shade",
                      type: "video",
                      key: 1,
                    },
                    {
                      src:
                        (REACT_APP_CDN_PATH || "") +
                        "/images/PaulMilinski/Cliffside Cascade_small.mp4",
                      altText: "Cliffside Cascade",
                      type: "video",
                      key: 2,
                    },
                    {
                      src:
                        (REACT_APP_CDN_PATH || "") +
                        "/images/PaulMilinski/Natures Invitation_small.mp4",
                      altText: "Natures Invitation",
                      type: "video",
                      key: 3,
                    },
                  ]}
                  twitter="https://twitter.com/paul_milinski"
                  insta="https://www.instagram.com/paul_milinski"
                  linkedin="https://www.linkedin.com/in/paul-milinski"
                  link="https://milinski.studio/"
                />
              </div>
            </Col>
          </Row>
        </Row>
      </MintingWrapper>

      <Container>
        <ImageContentSplit
          title={context.t("teaser.benefits.title")}
          content={context.t("teaser.benefits.copy")}
          imageUrl={
            (REACT_APP_CDN_PATH || "") +
            "/images/Samsung_Orig_Wordmark_WHITE_RGB.png"
          }
          ctaLink={"/community/benefits/"}
          ctaText={context.t("teaser.benefits.cta")}
        />
      </Container>

      <Container className="bigger-margin-top bigger-margin-bottom">
        <Faq faqListSlugs={["tx1ge", "minting"]} />
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
TX1GenesisMint.contextTypes = {
  t: PropTypes.func,
};

TX1GenesisMint.propTypes = {
  mintTierId: PropTypes.string,
};

/** export the component as redux connected component */
export default TX1GenesisMint;
